import React, { useContext, useEffect, useState } from "react";
import { ColorPicker, Form } from "antd";
import { IconPicker } from "react-fa-icon-picker";
import ModalTags from "../GeoUnit/ModalTags";
import { context } from "../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";

const GalleryForm = () => {
    const [form] = Form.useForm();
    // state
    const [isEditSelected, setIsEditSelected] = useState(false);
    const [inputTitleStyle, setInputTitleStyle] = useState({
        width: "100%",
        outline: "0",
    });
    const [inputDescriptionStyle, setDescriptionInputStyle] = useState({
        width: "100%",
        outline: "0",
    });
    // context
    const {
        selectedGalleryId,
        setGalleryTags,
        galleryTitle,
        setGalleryTitle,
        galleryColor,
        setGalleryColor,
        galleryIcon,
        setGalleryIcon,
        setGalleryMedia,
        setGalleryDescription,
        galleryDescription,
    } = useContext(context);
    // useEffect
    useEffect(() => {
        if (selectedGalleryId) {
            http.get(`${config.parkopoloApi}/api/Gallery/${selectedGalleryId}`)
                .then((res) => {
                    setGalleryTitle(res.data.result.title);
                    setGalleryDescription(res.data.result.description);
                    setGalleryTags(res.data.result.tags);
                    setGalleryMedia(res.data.result.media);
                    // setGalleryColor(res.data.result.color);
                    // setGalleryIcon(res.data.result.icon);
                })
                .catch((err) => {
                    console.log(err);
                });
            setIsEditSelected(true);
        }
    }, []);

    // functions

    const handleTitleChange = (e) => {
        setGalleryTitle(e.target.value);
    };
    const handleDescriptionChange = (e) => {
        setGalleryDescription(e.target.value);
    };
    const handleColorChange = () => {
        const color = document.querySelector(
            ".ant-color-picker-trigger-text"
        ).innerText;
        setGalleryColor(color);
    };
    const handleIconChange = (e) => {
        setGalleryIcon(e);
    };
    // const inputStyle =
    return (
        <div
            style={{
                direction: "rtl",
                display: "flex",
                gap: "15px",
                margin: "15px",
            }}
        >
            <Form
                layout="vertical"
                form={form}
                name="control-hooks"
                style={{
                    width: "100%",
                }}
            >
                <div style={{ display: "flex", gap: "2rem" }}>
                    <Form.Item
                        name="عنوان"
                        label="عنوان"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {galleryTitle}
                        </h4>
                        <input
                            style={inputTitleStyle}
                            className="ant-input css-dev-only-do-not-override-lzp0br css-dev-only-do-not-override-lzp0br"
                            type="text"
                            value={isEditSelected ? galleryTitle : null}
                            onChange={handleTitleChange}
                            placeholder="عنوان را وارد کنید"
                            onFocus={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    outline: "1px solid #48D1CC",
                                    borderColor: "#48D1CC",
                                };
                                setInputTitleStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                            }}
                            onBlur={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    outline: "",
                                    borderColor: "",
                                };
                                setInputTitleStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                            }}
                            onMouseEnter={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    borderColor: "#48D1CC",
                                };
                                setInputTitleStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                            }}
                            onMouseLeave={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    borderColor: "",
                                };
                                setInputTitleStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="توضیحات"
                        label="توضیحات"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {galleryDescription}
                        </h4>
                        <input
                            style={inputDescriptionStyle}
                            className="ant-input css-dev-only-do-not-override-lzp0br css-dev-only-do-not-override-lzp0br"
                            type="text"
                            value={isEditSelected ? galleryDescription : null}
                            onChange={handleDescriptionChange}
                            placeholder="توضیحات را وارد کنید"
                            onFocus={() => {
                                const updatedStyle = {
                                    ...inputDescriptionStyle,
                                    outline: "1px solid #48D1CC",
                                    borderColor: "#48D1CC",
                                };
                                setDescriptionInputStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                            }}
                            onBlur={() => {
                                const updatedStyle = {
                                    ...inputDescriptionStyle,
                                    outline: "",
                                    borderColor: "",
                                };
                                setDescriptionInputStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                            }}
                            onMouseEnter={() => {
                                const updatedStyle = {
                                    ...inputDescriptionStyle,
                                    borderColor: "#48D1CC",
                                };
                                setDescriptionInputStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                            }}
                            onMouseLeave={() => {
                                const updatedStyle = {
                                    ...inputDescriptionStyle,
                                    borderColor: "",
                                };
                                setDescriptionInputStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                            }}
                        />
                    </Form.Item>
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                    }}
                >
                    <Form.Item label="آیکون" name="آیکون">
                        <IconPicker
                            value={galleryIcon}
                            buttonStyles={{
                                padding: "0 2.5rem",
                                border: "1px solid silver",
                                width: "100%",
                            }}
                            onChange={(e) => handleIconChange(e)}
                        />
                    </Form.Item>
                    {isEditSelected ? (
                        <i
                            className={`fa ${galleryIcon
                                .split(/(?=[A-Z])/)
                                .map((word) => word.toLowerCase())
                                .join("-")}`}
                            style={{
                                fontSize: "30px",
                                color: `${galleryColor}`,
                            }}
                        />
                    ) : null}

                    <Form.Item label="رنگ" name="رنگ">
                        <ColorPicker
                            placement="top"
                            defaultValue={galleryColor}
                            onChange={handleColorChange}
                            style={{
                                padding: "1.5rem",
                                width: "100%",
                            }}
                            showText
                        />
                    </Form.Item>
                </div>
                <Form.Item name="تگ" label="تگ ها">
                    <div>
                        <ModalTags section="gallery" />
                    </div>
                </Form.Item>
            </Form>
        </div>
    );
};

export default GalleryForm;
